var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"no-styling":""}},[_c('coupon-list',{attrs:{"coupons":_vm.coupons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }